import { useQuery } from "react-query"

import { getContactList } from "./api";
import { ContactListData } from "../types/ContactListData";

// This data service pattern is based on this article: https://javascript.plainenglish.io/proper-data-service-architecture-in-react-b8348e365e4a

// this type is company wide API interface, typically imported from common package
type DataQueryOutput<T> = {
    data: T,
    loading: boolean,
    error: string | null,
}

export function useContactList(): DataQueryOutput<ContactListData|undefined> {
    const {data, isLoading, error} = useQuery({ queryKey: ['contacts'], queryFn: getContactList});

    const results: DataQueryOutput<ContactListData|undefined> = {
        data: data,
        loading: isLoading,
        error: `error: ${error}`
    }

    return results;
}